<div>
  <ppt-actions-toolbar
    [reportData]="reportData"
    [currentView]="currentView"
    [templates]="templateFieldsCatalog"
    [recordsCount]="summaryRecords.length"
    [requiresRecordNavigation]="false"
    [requiresSelectTempElement]="true"
    [isUKFeaturesEnabled]="isUKFeaturesEnabled"
    (templateAndViewChange)="onTemplateSelectedLater($event)"
  ></ppt-actions-toolbar>
</div>
<div class="map">
  <ng-container
    [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-summary-map'"
    [ngTemplateOutletContext]="{
      content: showHeader,
      summaryAddressPaths: summaryAddressPaths,
      isGroupByProperty: reportOptions.groupByBuilding,
    }"
  ></ng-container>
</div>

<ng-template #showHeader>
  <div class="map-header print-hidden">
    <span class="entity-records-info">
      <span class="entity-list"
        >{{ 'entities.' + (reportOptions.groupByBuilding ? 'property' : reportData.entity) | xTranslate }}
        {{ 'template.list' | xTranslate }} &nbsp;&nbsp;&nbsp; {{ summaryRecords.length }}
      </span>
      <ng-container *ngIf="reportData.records.length > 1; else singleRecord">
        {{ 'recordPPT.records' | xTranslate }}
      </ng-container>
      <ng-template #singleRecord>
        {{ 'recordPPT.record' | xTranslate }}
      </ng-template>
    </span>
  </div>
</ng-template>

<ng-container *ngIf="bodyGroups?.length; else spinnerTemp">
  <ul
    cdkDropList
    cdkDropListOrientation="vertical"
    *ngIf="reportData.entity !== 'tim'"
    (cdkDropListDropped)="onReorder($event)"
  >
    <li *ngFor="let record of summaryRecords; let order = index" cdkDrag cdkDragLockAxis="y">
      <ng-container *ngIf="!reportOptions.groupByBuilding">
        <mat-icon class="handle print-hidden" svgIcon="alt-handle-icon" color="y-icon" cdkDragHandle></mat-icon>
        <mat-icon
          class="green-close print-hidden"
          color="y-icon"
          svgIcon="close-icon-grey"
          (click)="removeRecordFromReport(record, order)"
        >
        </mat-icon>
        <ng-container
          [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
          [ngTemplateOutletContext]="{
            classes: '',
            urlParams: record | reportRecordRouteFn: { templateId: currentView.templateId, entity: reportData.entity },
            content: goToIcon,
            reportEntity: this.reportData.entity,
            edpRecordId: record.edpRecordId,
          }"
        ></ng-container>
        <ng-template #goToIcon>
          <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
        </ng-template>
      </ng-container>
      <p>
        <ng-container *ngFor="let field of bodyFields">
          <span
            *ngIf="
              record
                | isFieldVisible: { templateId: currentView.templateId, field: field, reportOptions: reportOptions }
            "
          >
            {{
              record
                | reportFieldFormatter
                  : { templateId: currentView.templateId, field: field, joinString: true, onlyUrl: false }
                | async
            }}
          </span>
        </ng-container>
      </p>
    </li>
  </ul>
</ng-container>
<ng-template #spinnerTemp> </ng-template>
